var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.274,
    height: 14.274,
    viewBox: "0 0 14.274 14.274",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "information",
    transform: "translate(14.274 14.274) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8335",
    "data-name": "Path 8335",
    d: "M7.137,0a7.137,7.137,0,1,0,7.137,7.137A7.145,7.145,0,0,0,7.137,0Zm0,12.976a5.839,5.839,0,1,1,5.839-5.839A5.846,5.846,0,0,1,7.137,12.976Z",
    fill: "#ea555f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8336",
    "data-name": "Path 8336",
    d: "M145.867,70a.865.865,0,1,0,.865.865A.866.866,0,0,0,145.867,70Z",
    transform: "translate(-138.73 -66.972)",
    fill: "#ea555f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8337",
    "data-name": "Path 8337",
    d: "M150.649,140a.649.649,0,0,0-.649.649v3.893a.649.649,0,0,0,1.3,0v-3.893A.649.649,0,0,0,150.649,140Z",
    transform: "translate(-143.512 -133.944)",
    fill: "#ea555f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.b5e537ab93cd1a109ae38fd10a3137d4.svg";
export { ForwardRef as ReactComponent };